import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import {OptionNavigationPanelBottom, OptionNavigationPanelMore} from "../../../../layout/navigation/@const";
import AppLoader_AIChat from "../../../../app/ai-chat/app-loader";
import {featureAccess} from "../../../gd/access-control/feature-access/feature-access";
import {Feature} from "../../../gd/access-control/feature-access/const";
import {UIType} from "../../../../layout/ui/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";


export class SpaceAIChat extends SpaceProto {

    constructor() {
        super(NavigationSectionType.AI_CHAT)

        this.title              = "AI Assistant"
        this.svgIcon            = "isvg-ask-ai"

        this.defaultPosition    = NavigationButtonPosition.BOTTOM

        switch (gd.ui.type) {

            case UIType.ASANA:
            case UIType.TEAMS:
                this.positions = []
                break

            default:
                this.positions          = [NavigationButtonPosition.BOTTOM, NavigationButtonPosition.MORE]
                break

        }
    }

    get position() {
        // patch
        if (gd.ui.type === UIType.ASANA || gd.ui.type === UIType.TEAMS) {
            return NavigationButtonPosition.STATIC
        }

        return super.position
    }

    set position(position: NavigationButtonPosition) {
        super.position = position
    }

    get navigationPanelLabel():string|null {

        if (gd.ui.type === UIType.ASANA || gd.ui.type === UIType.TEAMS) {
            return null
        }

        return "AI"
    }

    onClick = () => {

        if (!featureAccess(Feature.AI)) {
            gd.modals.other.upgrade(Feature.AI)
            return
        }

        if (!!gd.layout.right.app) {
            // gd.layout.right.hide()
            gd.layout.rightMain.hide()
        } else {
            // gd.layout.right.loadAndRun(AppLoader_AIChat)
            gd.layout.rightMain.loadAndRun(AppLoader_AIChat)
        }
    }

    get navigationStructureConfig() {

        return {
            id              : NavigationSectionType.AI_CHAT,
            type            : NavigationSectionType.AI_CHAT,
            icon            : "i5-default-ai",
            hint            : "AI Chat",
            // renderComponent : Navigation_ButtonAIChat,
            renderComponent : Navigation_ButtonGenericDeprecated,
            onClick         : this.onClick,
            position        : this.position,
        }

    }



}
